const DEFAULT_BRANDING = { color: '#0094ff', icon: 'link', pack: 'fas' };
let domainBrandings = {};

export const loadPlatformBrandings = async () => {
  domainBrandings = await fetch('/config/platforms.json')
    .then(response => response.json())
    .catch(error => console.error('Error loading domain colors:', error));
  // Update state here
};

export function getBrandingForDomain(url) {
  // Extract the domain from the URL
  const domain = new URL(url).hostname;

  // Remove all subdomains from the domain
  const rootDomain = domain.replace(/^(www\.)/, '').split('.').slice(-2).join('.');

  // Fetch the color for the root domain
  return domainBrandings[rootDomain] || DEFAULT_BRANDING;
}
